import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, onBeforeUnmount, ref } from 'vue';
import SidebarCard from '@/components/global/sidebar/SidebarCard.vue';
import { UploadFile } from 'ant-design-vue/types/upload';
import Attachment from '@/models/Attachment';
import { convertFileToAntdFile } from '@/helpers/CmsIndexHelper';
import Image from '@/models/Image';
// @ts-ignore
import downloadFile from 'downloadjs';
import { Upload } from 'ant-design-vue';
import { EventBus } from '@/helpers/EventBusHelper';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import NewsAttachmentRepository from '@/modules/Statistics/CMS/api/repositories/NewsAttachmentRepository';
import NewsAttachment from '@/modules/Statistics/CMS/api/models/NewsAttachment';
import { CustomRequestParameters } from '@/interfaces/general/CustomRequestParameters';
import { customHandlerForFileUpload } from '@/helpers/NewsAttachment/NewsAttachmentHelper';
import { LoadingOverlayHelper } from '@/helpers/LoadingOverlayHelper';

interface Props {
    newsId?: string;
    isReadOnly?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsAttachment',
  props: {
    newsId: { default: undefined },
    isReadOnly: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { newsId: string, isReadOnly: boolean };

const UploadDragger = Upload.Dragger;



const { proxy } = getCurrentInstance()!;

const fetchedNewsId = ref<string | null>(null);
const loading = ref<string | null>(null);
const showDropzone = ref(false);
// const attachments: NewsAttachment[] = [];
const temporaryAttachmentsForUpload = ref<File[] | null>(null);
const loadingOverlay = new LoadingOverlayHelper(proxy as any, {});

// hidding of the dropzone is delayed, to prevent flickering effect when draging over different child components
const toggleDropzineTimer = ref<NodeJS.Timeout | undefined>(undefined);
const attachments = ref<any>([]);

// const attachments = computed((): NewsAttachment[] => {
//     return NewsAttachmentRepository.getByNewsId(props.newsId);
// });

async function initializeNewsAttachment() {
    const response = await NewsAttachment.getNewsAttachmentByNewsId(props.newsId!);
    attachments.value = response.data;
}

function addNewAttachment(file: File) {
    attachments.value.push(file);
}

async function customRequest(customRequestParameters: CustomRequestParameters) {
    await customHandlerForFileUpload(customRequestParameters, String(props.newsId || fetchedNewsId.value));
    await initializeNewsAttachment();
}

async function manualUpload(file: any) {
    if ((!props.newsId && !fetchedNewsId.value) || !file.uid) {
        return;
    }

    await customRequest({
        file,
        onSuccess: (formData: FormData) => {
            return;
        },
        onError: () => {
            return;
        },
    });
    return false;
}

// Add files manually which will be uploaded or canceled if not saved
function uploadTemporarySavedFiles(id: string) {
    fetchedNewsId.value = id;

    attachments.value?.forEach(async (file: File) => {
        await manualUpload(file);
    });
}

function startLoading(newsAttachmentId: string) {
    loading.value = newsAttachmentId;
}

function endLoading() {
    loading.value = null;
}

async function onRemove(newsAttachmentForDelete: NewsAttachment) {
    // Delete locally if it is not saved yet
    if (newsAttachmentForDelete.uid) {
        attachments.value = attachments.value.filter(
            (attachment: NewsAttachment) => attachment.uid !== newsAttachmentForDelete.uid,
        );
    } else {
        startLoading(newsAttachmentForDelete.id);
        loadingOverlay.start();

        try {
            await NewsAttachment.deleteExisting(newsAttachmentForDelete.id);

            // Delete locally
            attachments.value = attachments.value.filter(
                (attachment: NewsAttachment) => attachment.id !== newsAttachmentForDelete.id,
            );
        } catch (e) {
            (proxy as any).$notification.error({
                message: proxy?.$t('Greška') as string,
                description: proxy?.$t('Došlo je do greške prilikom brisanja priloga') as string,
            });
        } finally {
            loadingOverlay.stop();
        }

        (proxy as any).$notification.success({
            message: proxy?.$t('Uspješno') as string,
            description: proxy?.$t('Prilog je uspješno obrisan') as string,
        });
        endLoading();
    }
}

function onOpenRemoveModal(newsAttachmentForDelete: NewsAttachment) {
    return new Promise((resolve) => {
        (proxy as any).$confirm({
            title: proxy?.$t('Jeste li sigurni da želite primjeniti ove promjene?') as string,
            content: '',
            okText: proxy?.$t('Da') as string,
            okType: 'danger',
            cancelText: proxy?.$t('Ne') as string,
            class: 'c-delete-modal',
            onOk: () => {
                onRemove(newsAttachmentForDelete);
                resolve(null);
            },
            onCancel: () => {
                resolve(null);
            },
        });
    });
}

function downloadLocalFile(attachment: File) {
    const reader = new FileReader();

    // download local file
    reader.onload = (e) => {
        const data = e?.target?.result;
        downloadFile(data, attachment.name);
    };
    reader.readAsDataURL(attachment);
}

async function onPreview(newsAttachment: any) {
    if (newsAttachment.uid) {
        downloadLocalFile(newsAttachment);
    } else {
        let blob;
        startLoading(newsAttachment.id);
        try {
            blob = await NewsAttachment.getBlob(newsAttachment.attachment as string);
        } catch (e) {
            if (e instanceof Error) {
                throw new Error(e.message);
            } else {
                throw new Error(
                    (e as { response: { data: { meta: { message: string } } } }).response.data.meta.message,
                );
            }
            return;
        }
        downloadFile(blob.data, newsAttachment.displayName);
        endLoading();
    }
}

(async function () {
    await initializeNewsAttachment();

    EventBus.$on(EventBusEvents.uploadNewsAttachment, uploadTemporarySavedFiles);
})();

onBeforeUnmount(() => {
    EventBus.$off(EventBusEvents.uploadNewsAttachment);
});

return { __sfc: true,UploadDragger, props, proxy, fetchedNewsId, loading, showDropzone, temporaryAttachmentsForUpload, loadingOverlay, toggleDropzineTimer, attachments, initializeNewsAttachment, addNewAttachment, customRequest, manualUpload, uploadTemporarySavedFiles, startLoading, endLoading, onRemove, onOpenRemoveModal, downloadLocalFile, onPreview }
}

})